export default function scrollTop() {
      $(document).ready(function () {
          $("#slider").on("input", function() {
              var sliderPos = $(this).val();
              $('.home-banner-draw').css('clip-path', 'inset(0%  0% 0%' + sliderPos + '%)');
              $('.banner-home-button').css('left', 'calc(' + sliderPos + '% - 32px)');
          });
      });
  }